import { Button, Input, Form } from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { useLocalization } from "@i18n";
import { Filter } from "lucide-react";
import { cleanEmptyStrings } from "@shared/hooks";

import { AdminUserFilterData } from "../../schemas";

interface AdminUsersFilterProps {
  onFilter: (data: Partial<AdminUserFilterData>) => void;
  onClear: () => void;
  initialFilters?: Partial<AdminUserFilterData>;
}

export const AdminUsersFilter = ({
  onFilter,
  onClear,
  initialFilters,
}: AdminUsersFilterProps) => {
  const { translate } = useLocalization();

  const form = useForm<AdminUserFilterData>({
    defaultValues: {
      name: initialFilters?.name ?? "",
      email: initialFilters?.email ?? "",
    },
  });

  const handleFilter = (data: AdminUserFilterData) => {
    onFilter(cleanEmptyStrings(data));
  };

  const handleClear = () => {
    form.reset({ name: "", email: "" });
    onClear();
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleFilter)}>
        <div className="flex flex-column gap-5">
          <Input
            control={form.control}
            label={`${translate("admin.users.form.label.name")}:`}
            name="name"
            type="text"
            placeholder={translate("admin.users.form.placeholder.filterName")}
          />
          <Input
            control={form.control}
            label={`${translate("admin.users.form.label.email")}:`}
            name="email"
            type="text"
            placeholder={translate("admin.users.form.placeholder.filterEmail")}
          />
        </div>
        <div className="flex justify-end mb-4 gap-4">
          <Button type="button" variant="secondary" onClick={handleClear}>
            {translate("admin.users.button.clearFilters")}
          </Button>
          <Button type="submit" iconLeft={<Filter fill="currentColor" />}>
            {translate("admin.users.button.filter")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
